import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

export const useTabVisibility = () => {
  const location = useLocation();
  
  // Main tab routes where tabs should be visible
  const mainTabRoutes = [
    '/goals',
    '/calendar', 
    '/announcements',
    '/settings'
  ];
  
  // Check if current route is a main tab route
  const shouldShowTabs = isMobile ? (mainTabRoutes.some(route => location.pathname === route)) : true;
  
  return shouldShowTabs;
};
